<template>
  <div class="layout" :class="{ 'standalone-layout': standalone }">
    <n-config-provider :theme-overrides="themeOverrides">
      <n-dialog-provider  color="#789ADE">
        <n-message-provider :container-style="{ top: 'calc(var(--app-safe-top) + 12px)', left: 'var(--app-safe-left)', right: 'var(--app-safe-right)' }">
          <RequestFeedback />
          <router-view></router-view>
        </n-message-provider>
      </n-dialog-provider>
    </n-config-provider>
  </div>
</template>

<script lang="ts">
import { defineComponent,reactive,toRefs,ref,onMounted,onBeforeUnmount } from 'vue';
import { NConfigProvider,NDialogProvider,NMessageProvider } from 'naive-ui';
import RequestFeedback from './components/RequestFeedback.vue';

export default defineComponent({
  name: 'AppProvider',
  components: {
    RequestFeedback,
    NConfigProvider,
    NMessageProvider,
    NDialogProvider,
  },

  setup () {
      const standalone = ref(false)
      const displayMode = window.matchMedia('(display-mode: standalone)')
      const syncDisplayMode = () => { standalone.value = displayMode.matches || !!(navigator as Navigator & { standalone?: boolean }).standalone }
      syncDisplayMode()
      onMounted(() => {
        if (displayMode.addEventListener) displayMode.addEventListener('change', syncDisplayMode)
        else displayMode.addListener(syncDisplayMode)
      })
      onBeforeUnmount(() => {
        if (displayMode.removeEventListener) displayMode.removeEventListener('change', syncDisplayMode)
        else displayMode.removeListener(syncDisplayMode)
      })
      const state = reactive({
        count: 0,
      })

      //弹框 tag，select，datepicker 控件 样式
      const themeOverrides = {
          Dialog: {
            iconColorSuccess: "#789ADE",
          },
          Button:{
            colorHoverSuccess:"#789ADE",
            colorSuccess:"#789ADE",
            textColorGhostHover:"#789ADE",
            borderHover:"1px solid #789ADE",
          }
      }
    
      return {
        standalone,
        themeOverrides,
        ...toRefs(state),
      }
    }
});
</script>

<style>
:root {
  --app-safe-top: env(safe-area-inset-top, 0px);
  --app-safe-right: env(safe-area-inset-right, 0px);
  --app-safe-bottom: env(safe-area-inset-bottom, 0px);
  --app-safe-left: env(safe-area-inset-left, 0px);
  background-color: #EAEEF6;
}

html.timer-focus-active,
html.timer-focus-active body {
  background-color: #202228;
  overflow: hidden;
}

body {
  background-color: #EAEEF6;
  font-family:'PingFang HK','Microsoft YaHei',华文细黑, 宋体, 'Times New Roman', Times, serif;
  user-select: none;
  box-sizing: border-box;
}

div{
  box-sizing: border-box;
}

img{
  border: none;
}

* {
  margin: 0px;
  padding: 0px;
}

ul,li{
  list-style: none;
}

a{
  text-decoration: none;
}

.layout{
  /* border: 1px solid rosybrown; */
  width: 100%;
  max-width: 1440px;
  min-width: 0;
  margin: 0 auto;
  padding: var(--app-safe-top) var(--app-safe-right) var(--app-safe-bottom) var(--app-safe-left);
}

/* The translucent iOS status bar needs a readable dark backing outside focus too. */
.standalone-layout::before {
  content: '';
  position: fixed;
  z-index: 999;
  inset: 0 0 auto;
  height: var(--app-safe-top);
  background: #202228;
  pointer-events: none;
}

@media (max-width: 620px), (max-width: 900px) and (orientation: landscape) and (max-height: 520px) {
  .main-layout > .content-layout {
    min-width: 0;
  }
}


.line{
    /* width: 816px; */
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px;
}

.input-group{
    padding: 0 10px;
}

.flex-group{
    display: flex;
    flex-direction: row;
    align-items: center;
}

.t-input,.t-textarea{
  box-sizing: border-box;
  outline:none;
  background: #ffffff;

  border: 1px solid #789ADE;
  border-radius: 72px;
  padding: 0 18px;
}

.t-textarea{
  border-radius: 12px;
  padding:5px 18px;
}

.t-input[type="text"],.t-input[type="number"]{
  height: 35px;
  font-size: 14px;
  color: #3C4551;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"]{
  -moz-appearance: textfield;
}

.t-input:focus,.t-input:active,.t-textarea:focus,.t-textarea:active{
    border:1px solid #789ade;
    box-shadow: 0 0 0 2px rgba(120, 154, 222, 0.2);
}

.t-input::-webkit-input-placeholder{
    color: #C8D3F9;
}
.t-input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color: #C8D3F9;
}
.t-input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color: #C8D3F9;
}
.t-input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color: #C8D3F9;
}

.lg-input{
  width: 388px;
}

.md-input{
  width: 224px;
}

.sm-input{
  width: 70px;
}

.n-input{
    border-radius: 72px !important;
}

.unit{
    width: 70px;
    margin: 0 5px;
}

.unitDisp{
    padding: 0 5px;
}

/* modal */
.modal-body label{
    font-size: 18px;
    color: #444B59;
    letter-spacing: 0.1em;
    text-indent:0.1em;
    text-align: right;
}

/* modal */

/* progress */
/* 设置进度条中字体 */
.ep-container p {
    color:#2F80ED;
}

.left-time{
    text-align: center;
    font-size: 14px;
    line-height: 12px;
    color: #2F80ED;
}
/* progerss */

/* icon */

.icon,.icon-16{
    width: 16px;
    height: 16px;
}

.icon-20{
  width: 20px;
  height: 20px;
}

.icon-32{
    width: 32px;
    height: 32px;
}

.icon-plan{
    background: url(@/assets/icon-plan-time-svg.svg) no-repeat center center;
    background-size: contain;
}

.icon-rest{
    background: url(@/assets/icon-rest-time.svg) no-repeat center center;
    background-size: contain;
}

.icon-priority{
    width: 10px;
    height: 10px;
    background: url(@/assets/icon-star.svg) no-repeat center center;
}

.icon-point{
    width: 12px;
    height: 12px;
    background: url(@/assets/icon-medal.svg) no-repeat center center;
    margin-top:1px;
}

.icon-point-uncompleted{
    width: 12px;
    height: 12px;
    background: url(@/assets/icon-medal-uncomplete.svg) no-repeat center center;
}

.icon-edit{
  background: url(@/assets/icon-edit.svg) no-repeat center center;
}

.icon-edit:hover{
  background: url(@/assets/icon-edit-active.svg) no-repeat center center;
}

.icon-delete{
  background: url(@/assets/icon-delete.svg) no-repeat center center;
}

.icon-delete:hover{
  background: url(@/assets/icon-delete-active.svg) no-repeat center center;
}
 
.icon-start{
  background: url(@/assets/icon-start.svg) no-repeat center center;
}

.icon-start:hover{
  background: url(@/assets/icon-start-active.svg) no-repeat center center;
}

.icon-pause{
  background: url(./assets/icon-pause.svg) no-repeat center center;
}

.icon-pause:hover{
  background: url(./assets/icon-pause-active.svg) no-repeat center center;
}

/* icon */
</style>
